// extracted by mini-css-extract-plugin
export default {"main-header":"header_main-header__OVVbe","custom-select":"header_custom-select__lKWoR"};